import { ApplicationPensionValues, LumpSumOptions } from '~/types';

export const getWithdrawalLabelValue = (pensionValues: ApplicationPensionValues) => {
    switch (pensionValues.withdrawals?.lumpSumOption) {
        case LumpSumOptions.MAXIMUM_TAX_FREE_CASH:
            return {
                label: 'All of my tax-free cash: ',
                value: pensionValues.maximumTaxFreeCash,
            };
        case LumpSumOptions.HALF_TAX_FREE_CASH:
            return {
                label: 'Half of my tax-free cash: ',
                value: pensionValues.halfTaxFreeCash,
            };
        case LumpSumOptions.SPECIFY:
            return {
                label: '',
                value: pensionValues.withdrawals?.lumpSum,
            };
        default:
            return {
                label: '',
                value: null,
            };
    }
};

export const formatDateOrdinal = (day?: number | string): string | undefined => {
    const n = typeof day === 'string' ? parseFloat(day) : day;
    if (!n || n < 1 || n > 31) return undefined;

    const suffixes = ['th', 'st', 'nd', 'rd'];
    const remainder = n % 10;
    const exception = Math.floor(n / 10) % 10 === 1;

    return `${n}${exception ? 'th' : suffixes[remainder] || 'th'}`;
};
